exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".WLCheckbox {\n  margin-left: 0.5em; }\n\n.WLLabel {\n  margin-left: 0.5em; }\n\n.WLHeader {\n  margin-top: 3em; }\n\n.archive-input-field {\n  margin-bottom: 1rem; }\n", ""]);

